import React, {ReactElement, useState, useEffect} from 'react';

import './App.css';
import Item from "./Model/Item";
import SetGenerator from "./Service/SetGenerator";
import Grid from "./Component/Grid";
const STORAGE_PREFIX: string = "bingo-";

const setGeneratopr = new SetGenerator();

const App: () => ReactElement = (): ReactElement => {
    const [items, setItems] = useState<Item[]>([]);
    const [set, setSet] = useState<string | undefined>(undefined);
    const [seed, setSeed] = useState<string|undefined>(undefined);
    const [error, setError] = useState<boolean>(false);

    useEffect((): void => {
        const params: URLSearchParams = new URLSearchParams(window.location.search);
        const set: string | null = params.get("set");
        const seed: string | null = params.get("seed");

        if (set && seed) {
            // use them
            // redirect
            localStorage.setItem(`${STORAGE_PREFIX}set`, set);
            localStorage.setItem(`${STORAGE_PREFIX}seed`, seed);
            setSet(set);
            setSeed(seed);

            window.location.replace(window.location.href.split("?")[0]);

            return;
        }

        const setFromStorage: string | null = localStorage.getItem(`${STORAGE_PREFIX}set`);
        const seedFromStorage: string | null = localStorage.getItem(`${STORAGE_PREFIX}seed`);
        if (setFromStorage && seedFromStorage) {
            setSet(setFromStorage);
            setSeed(seedFromStorage);

            return;
        }


        setError(true);
    }, [set, seed]);

    useEffect((): void => {
        if (! set || ! seed) {
            return;
        }

        const generatedItems: Item[] = setGeneratopr.generate(set, seed);

        setItems(generatedItems);
    }, [set, seed]);

    if (error) {
        return <div>
            Uh-oh, something went wrong!
        </div>;
    }

    return <div>
        {/*Bingo!*/}
        {/**/}
        {/*{set}, {seed}*/}
        {/*<br />*/}
        <Grid items={items} />
    </div>;
}

export default App;
